
import { Plan } from '../types';

export const plans: Plan[] = [
  {
    id: '1',
    name: 'Basis Abonnement',
    provider: 'Telmore',
    provider_id: 'telmore.png',
    price: 99,
    data_allowance: '5GB',
    contract_length: 'Ingen binding',
    minutes: 'Ubegrænset',
    texts: 'Ubegrænset',
    roaming: 'EU',
    has_5g: false,
    features: [
      'Dataforbrug i Danmark',
      'Wi-Fi opkald',
      'Telmore fordele'
    ],
    rating: 4.1,
    review_count: 245,
    popularity: 85,
    link: '#',
    description: 'Perfekt til lette brugere, der har brug for pålidelig dækning',
  },
  {
    id: '2',
    name: 'Fri Data',
    provider: 'CBB',
    provider_id: 'cbb.png',
    price: 149,
    original_price: 199,
    data_allowance: 'Ubegrænset',
    contract_length: '6 måneder',
    minutes: 'Ubegrænset',
    texts: 'Ubegrænset',
    roaming: 'EU og udvalgte lande',
    has_5g: true,
    features: [
      'HD streaming',
      'Dataforbrug (15GB) til hotspot',
      '5G adgang',
      'Musik streaming inkluderet'
    ],
    rating: 4.7,
    review_count: 512,
    popularity: 92,
    link: '#',
    description: 'Vores mest populære abonnement med ubegrænset højhastighedsdata',
    promo_code: 'SOMMER2023',
    promo_ends: '2023-08-31',
  },
  {
    id: '3',
    name: 'Data Sparer',
    provider: 'Oister',
    provider_id: 'oister.png',
    price: 79,
    price_label: '79 kr./md i 6 måneder, derefter 99 kr./md',
    data_allowance: '2GB',
    contract_length: 'Ingen binding',
    minutes: 'Ubegrænset',
    texts: 'Ubegrænset',
    roaming: 'Ingen',
    has_5g: false,
    features: [
      'Data overføres til næste måned',
      'Musik streaming tæller ikke med i dataforbrug',
      'Wi-Fi opkald'
    ],
    rating: 3.9,
    review_count: 187,
    popularity: 70,
    link: '#',
    description: 'Billigt abonnement til brugere med minimalt dataforbrug',
  },
  {
    id: '4',
    name: 'Familie Pakke',
    provider: 'Telenor',
    provider_id: 'telenor.png',
    price: 199,
    data_allowance: '10GB',
    contract_length: '12 måneder',
    minutes: 'Ubegrænset',
    texts: 'Ubegrænset',
    roaming: 'EU',
    has_5g: true,
    features: [
      'Del data med familiemedlemmer',
      'Forældrekontrol',
      'Gratis enhedsbeskyttelse',
      'Familierabat tilgængelig'
    ],
    rating: 4.3,
    review_count: 309,
    popularity: 88,
    link: '#',
    description: 'Perfekt til familier der deler data på tværs af flere linjer',
  },
  {
    id: '5',
    name: 'Fri Data Max',
    provider: 'YouSee',
    provider_id: 'yousee.png',
    price: 249,
    data_allowance: 'Ubegrænset',
    contract_length: '6 måneder',
    minutes: 'Ubegrænset',
    texts: 'Ubegrænset',
    roaming: 'Verden',
    has_5g: true,
    features: [
      'Ubegrænset data uden hastighedsbegrænsning',
      'HD streaming',
      'Dataforbrug (30GB) til hotspot',
      'Inkluderet streamingstjenester',
      'International SMS til 200+ lande'
    ],
    rating: 4.8,
    review_count: 621,
    popularity: 94,
    link: '#',
    description: 'Premium ubegrænset abonnement med alle de ekstra ting, du har brug for',
  },
  {
    id: '6',
    name: 'Basis Data',
    provider: '3',
    provider_id: '3.png',
    price: 99,
    data_allowance: '3GB',
    contract_length: '3 måneder',
    minutes: 'Ubegrænset',
    texts: 'Ubegrænset',
    roaming: 'Ingen',
    has_5g: false,
    features: [
      'Hotspot muligt',
      'HD Voice & Wi-Fi opkald',
      '3 belønningsprogram'
    ],
    rating: 3.7,
    review_count: 142,
    popularity: 65,
    link: '#',
    description: 'Enkelt abonnement med lige præcis det, du har brug for',
  },
  {
    id: '7',
    name: 'Premium 5G',
    provider: 'TDC',
    provider_id: 'tdc.png',
    price: 299,
    original_price: 349,
    price_label: 'Første 3 måneder halv pris',
    data_allowance: '100GB',
    contract_length: '12 måneder',
    minutes: 'Ubegrænset',
    texts: 'Ubegrænset',
    roaming: 'EU og udvalgte lande',
    has_5g: true,
    features: [
      'Hurtigste 5G netværk',
      'Data overførsel',
      'Streaming tjenester inkluderet',
      'Gratis enhedsbeskyttelse',
      'Wi-Fi opkald & VoLTE'
    ],
    rating: 4.6,
    review_count: 378,
    popularity: 91,
    link: '#',
    description: 'Oplev lynhurtige 5G-hastigheder på Danmarks bedste netværk',
    promo_code: 'TDC5G2023',
    promo_ends: '2023-09-30',
  },
  {
    id: '8',
    name: 'Fri Basis',
    provider: 'Telia',
    provider_id: 'telia.png',
    price: 69,
    data_allowance: '1GB',
    contract_length: '1 måned',
    minutes: 'Ubegrænset',
    texts: 'Ubegrænset',
    roaming: 'EU',
    has_5g: false,
    features: [
      'Ingen binding - opsig når som helst',
      'Telia fordele og rabatter',
      'Wi-Fi opkald'
    ],
    rating: 4.0,
    review_count: 201,
    popularity: 75,
    link: '#',
    description: 'Fleksibelt månedligt abonnement uden langvarig forpligtelse',
  },
  {
    id: '9',
    name: 'Alt-i-en Plus',
    provider: 'Callme',
    provider_id: 'callme.png',
    price: 179,
    data_allowance: '30GB',
    contract_length: '6 måneder',
    minutes: 'Ubegrænset',
    texts: 'Ubegrænset',
    roaming: 'Verden',
    has_5g: true,
    features: [
      'Roam i hele verden',
      'Personligt hotspot inkluderet',
      'Stream uden at bruge data på udvalgte apps',
      'Fri streaming'
    ],
    rating: 4.5,
    review_count: 289,
    popularity: 87,
    link: '#',
    description: 'Funktionspakket abonnement med fantastiske roaming-fordele',
  },
  {
    id: '10',
    name: 'Erhverv Pro',
    provider: 'Telenor',
    provider_id: 'telenor.png',
    price: 249,
    data_allowance: 'Ubegrænset',
    contract_length: '12 måneder',
    minutes: 'Ubegrænset',
    texts: 'Ubegrænset',
    roaming: 'Verden',
    has_5g: true,
    features: [
      'Dedikeret erhvervssupport',
      'Microsoft 365 inkluderet',
      'Løfte om enhedsudskiftning',
      'Fast IP-adresse',
      'Secure Net beskyttelse'
    ],
    rating: 4.4,
    review_count: 156,
    popularity: 83,
    link: '#',
    description: 'Professionelt abonnement designet til erhvervsbrugere',
  }
];

export const featuredPlans = plans.filter(plan => plan.id === '2' || plan.id === '5' || plan.id === '7');
